import CButton from '@components/core/Button';

import CForm from '@components/form/Form';
import CSubForm from '@components/form/SubForm';
import CElement from '@components/form/Element';

import CCheckbox from '@components/form/input/Checkbox';
import CDatepicker from '@components/form/input/Datepicker';
import CInput from '@components/form/input/Input';
import CPassword from '@components/form/input/Password';
import CRadiogroup from '@components/form/input/Radiogroup';
import CTextarea from '@components/form/input/Textarea';
import CSelect from '@components/form/input/Select';
import CSelectSearch from '@components/form/input/SelectSearch';

export default {
    components: {
        CButton,
        CDatepicker,
        CForm,
        CElement,
        CCheckbox,
        CInput,
        CPassword,
        CRadiogroup,
        CSelect,
        CSelectSearch,
        CTextarea,
        CSubForm,
    },
    methods: {
    },
}